import { dayRankID, totalRankID } from '@/common/config';
import { getRankList } from './api';
import { oneToWan, secondToDate, formatTime } from './utils'
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable babel/camelcase */
import Vue from 'vue'
import { sortBy, cloneDeep, sortedIndex } from 'lodash-es'
import {
  ConfigData,
  ConfigListItemData,
  ContributeInfo,
  ReserveListData,
  ReserveListItemData,
  Award,
  UserInfo,
  RankDataList,
  RankDataItem
} from '../types'
import api from '@common/api'
import { jsonUrl } from '@/common/config'

// Vue.observable 创建可响应对象
export const store = Vue.observable({
  userInfo: {} as UserInfo,
  data: {} as Award,
  rankList: [] as any,
  totalRankList: [] as any,
  swiperData: {} as any,
})

export const mutations = {
  setUserInfo(userInfo: UserInfo) {
    store.userInfo = userInfo
  },
  setAwardData(data: Award) {
    store.data = data
  },
  setRankList(data: any) {
    store.rankList.push(data)
  },
  setTotalRankList(data: any) {
    store.totalRankList.push(data)
  },
  setSwiperList(data: any) {
    store.swiperData = data
  }
}


export const action = {
  async getUserInfo() {
    const res = await api.getUserInfo()
    mutations.setUserInfo(res as UserInfo)
  },
  async getAwardData() {
    const res = await api.getAwardData()
    mutations.setAwardData(res as Award)
  },
  async getSwiperData() {
    const res = await api.getSwiperList()
    console.log('resswiper', res)
    mutations.setSwiperList(res)
  },
  async getRankList(rankID: number) {
    const res = await getRankList(rankID)
    if (rankID === dayRankID) {
      let count = 0
      res.list.forEach((item: any) => {
        const dataItem: RankDataItem = {
          id: count,
          mid: item.account.mid,
          nickName: item.account.name,
          face: item.archive[0].account.face.includes('https')?item.archive[0].account.face:item.archive[0].account.face.replace('http', 'https'),
          cover: item.archive[0].pic.includes('https')?item.archive[0].pic:item.archive[0].pic.replace('http', 'https'),
          duration: secondToDate(item.archive[0].duration),
          play: oneToWan(item.archive[0].view),
          score: item.archive[0].score,
          show_link: item.archive[0].show_link,
          ctime: formatTime(item.archive[0].ctime),
          title: item.archive[0].title,
          active: count === 0 || count === 1 ? true : false,
          bvid: item.archive[0].bvid
        }
        count++
        mutations.setRankList(dataItem)
      });
    } else {
      let count = 0
      res.list.forEach((item: any) => {
        const dataItem: RankDataItem = {
          id: count,
          mid: item.archive[0].account.mid,
          nickName: item.archive[0].account.name,
          face: item.archive[0].account.face.includes('https')?item.archive[0].account.face:item.archive[0].account.face.replace('http', 'https'),
          cover: item.archive[0].pic.includes('https')?item.archive[0].pic:item.archive[0].pic.replace('http', 'https'),
          duration: secondToDate(item.archive[0].duration),
          play: oneToWan(item.archive[0].view),
          score: item.archive[0].score,
          show_link: item.archive[0].show_link,
          ctime: formatTime(item.archive[0].ctime),
          title: item.archive[0].title,
          active: count === 0 || count === 1 ? true : false,
          bvid: item.archive[0].bvid
        }
        count++
        mutations.setTotalRankList(dataItem)
      });
    }
  }
}
